import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ImageUrls } from '../../types';
import { WkAlfrescoApiService } from '../../services';

@Pipe({
  name: 'blobUrl',
  standalone: false,
})
export class BlobUrlPipe implements PipeTransform {
  constructor(
    private readonly apiService: WkAlfrescoApiService,
    private readonly sanitizer: DomSanitizer
  ) {}
  transform(
    url: string,
    urlsArray: ImageUrls[],
    user: any
  ): Observable<SafeUrl> {
    const isUrlAlreadyPresent = urlsArray.find(
      (ele: ImageUrls) => ele.apsUrl === url
    );
    if (isUrlAlreadyPresent) {
      return of(isUrlAlreadyPresent.safeUrl);
    }
    return from(
      this.apiService.callProcessClientCustomApi({
        path: `/${url.split('/').slice(3).join('/')}`,
        httpMethod: 'GET',
        contentTypes: [''],
        accepts: [''],
        responseType: 'blob',
      })
    ).pipe(
      map((imgBlob: Blob) => {
        const blobImageUrl = URL.createObjectURL(imgBlob);
        const safeBlobUrl = this.sanitizer.bypassSecurityTrustUrl(blobImageUrl);
        urlsArray.push({
          apsUrl: url,
          blobUrl: blobImageUrl,
          safeUrl: safeBlobUrl,
        });
        return safeBlobUrl;
      }),
      catchError(() => {
        user.pictureId = '';
        return of();
      })
    );
  }
}
